import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { IChartResponseData } from './types/chart-response';
import { ChartRoute } from './chart.route';

export const requestChartData = async (): Promise<IChartResponseData> =>
  cuverseApi.get<IChartResponseData>(ChartRoute.Chart()).then((res) => {
    return res?.data;
  });
